import styled from '@emotion/styled'

import { ApiPortfolioType } from '@/api'
import { LinkButton } from '@/components/core-v2'
import { PORTFOLIO_TYPE } from '@/constants'

import { PortfolioResult } from './finder'

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    padding: 24px 12px;
    background-color: var(--White96);
    color: var(--Graphite);
    text-align: left;
    border-top: 1px solid var(--White90);
    border-bottom: 1px solid var(--White90);
  }

  .name {
    border-left: none;
  }

  .classification {
    text-align: right;
    border-right: none;
  }

  td {
    border: 1px solid var(--White96);
    padding: 24px 12px;
  }
`

type PortfoliosTableProps = {
  onClickPortfolio: (id: string) => void
  portfolioType?: ApiPortfolioType
  portfolios: PortfolioResult[]
}

export const PortfoliosTable = ({
  onClickPortfolio,
  portfolioType,
  portfolios
}: PortfoliosTableProps) => {
  const filteredPortfolios = portfolioType
    ? portfolios.filter(port => port.portfolioType === portfolioType)
    : portfolios

  const title = portfolioType
    ? `${filteredPortfolios.length} ${PORTFOLIO_TYPE[portfolioType].value} portfolios available`
    : `${filteredPortfolios.length} portfolios available`
  return (
    <StyledTable>
      <thead>
        <tr>
          <th className="name">{title}</th>
          {
            // T0D0 - needs portfolio/minimal to return type
            !portfolioType && <th>Type</th>
          }
          <th>ID</th>
          <th className="classification">Classification</th>
        </tr>
      </thead>
      <tbody>
        {portfolios
          .filter(port => port.portfolioType === portfolioType)
          .map(p => (
            <tr key={p.name}>
              <td className="name">
                <LinkButton underline={false} onClick={() => onClickPortfolio(p.id)}>
                  {p.name}
                </LinkButton>
              </td>
              {
                // T0D0 - needs portfolio/minimal to return type
                !portfolioType && <td>Type</td>
              }
              <td>{p.id}</td>
              <td className="classification">{p.taxClassification}</td>
            </tr>
          ))}
      </tbody>
    </StyledTable>
  )
}
